/**
 * The Work-home period model (Matt, 2026-07-17) — the `?period=` window that
 * scopes the dashboard's "Due" section. Pure data + coercion, shared by the
 * server page/dashboard AND the client pill filter (`_period-filter.tsx`), so
 * it lives outside the "use client" boundary.
 */

export type WorkPeriod = "today" | "week" | "month" | "quarter" | "all";

export const WORK_PERIODS: readonly WorkPeriod[] = [
  "today",
  "week",
  "month",
  "quarter",
  "all",
];

export const PERIOD_LABEL: Record<WorkPeriod, string> = {
  today: "Today",
  week: "Week",
  month: "Month",
  quarter: "Quarter",
  all: "All",
};

/** The period's human window phrase — the Due section's aside + empty copy. */
export const PERIOD_PHRASE: Record<WorkPeriod, string> = {
  today: "today",
  week: "this week",
  month: "this month",
  quarter: "this quarter",
  all: "on the books",
};

export function coerceWorkPeriod(raw: string | string[] | undefined): WorkPeriod {
  return typeof raw === "string" && (WORK_PERIODS as readonly string[]).includes(raw)
    ? (raw as WorkPeriod)
    : "today";
}
